import { LoadState } from "../../constants/enums";
import { IUserProfile, IUsersState } from "./userProfile.types";

export const initialUser: IUserProfile = {
  assigned_phone_number: null,
  branch_code: null,
  branch_name: null,
  branch_uuid: null,
  city: null,
  country: null,
  created_by_name: "",
  created_by_uuid: "",
  csr: null,
  csr_code: null,
  date_of_birth: null,
  department: null,
  documents: null,
  email: "",
  fax: null,
  first_name: "",
  full_name: "",
  hire_date: null,
  home_phone: null,
  insert_ts: "",
  job_title: null,
  languages_known: null,
  last_day_at_work: null,
  last_name: "",
  linkedin_profile: null,
  marketer: null,
  marketer_code: null,
  mobile: null,
  mother_maiden_name: null,
  personal_email: "",
  photo: null,
  postal_code: null,
  producer_one: null,
  producer_one_code: null,
  producer_three: null,
  producer_three_code: null,
  producer_two: null,
  producer_two_code: null,
  province_or_state: null,
  role_uuid: "",
  role_value: "",
  shared_email: null,
  signature: null,
  status: "",
  street_address: null,
  unit_or_suite: null,
  user_dim_id: 10,
  user_dim_unique_id: 10,
  user_fact_id: 10,
  user_fact_unique_id: 10,
  user_profile_id: 10,
  user_profile_unique_id: 10,
  user_type: null,
  user_uuid: "",
};

export const initialUserProfileState: IUsersState = {
  users: {
    data: [],
    totalNumberOfRecords: 0,
    loading: LoadState.NotLoaded,
    user: initialUser,
    userLoading: LoadState.NotLoaded,
    error: null,
  },
};
